import { render, staticRenderFns } from "./AffidavitPersonalServiceStep.vue?vue&type=template&id=1d88f7ea"
import script from "./AffidavitPersonalServiceStep.vue?vue&type=script&lang=ts"
export * from "./AffidavitPersonalServiceStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports